export default "__VITE_ASSET__6c33bd81__"